import { render } from "./Swapper.vue?vue&type=template&id=345bd1ec&scoped=true"
import script from "./Swapper.vue?vue&type=script&lang=js"
export * from "./Swapper.vue?vue&type=script&lang=js"

import "./Swapper.vue?vue&type=style&index=0&id=345bd1ec&scoped=true&lang=scss"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345bd1ec"]])

export default __exports__